export const VALID_TAG_COLORS = ['blue', 'green', 'teal', 'yellow', 'red', 'purple', 'gray'] as const;
